module.exports = __webpack_public_path__ + "img/goto-examicon_tip.fb15e826.svg";